import {FeatureVariantAssignment} from '@udemy/graphql';

import {JbiEnhancedLectureVariant} from 'src/lib/experimentation-constants';

export function getJbiEnhancedLectureVariant(
    assignment: FeatureVariantAssignment | undefined,
): JbiEnhancedLectureVariant {
    if (!assignment || assignment.isLocalDefault) {
        return 'control';
    }

    const variant = assignment.configuration?.variant;
    if (variant === 'video' || variant === 'curriculum' || variant === 'summary') {
        return variant;
    }

    return 'control';
}
